import { render } from "./EtoileComponent.vue?vue&type=template&id=4aa10de7"
import script from "./EtoileComponent.vue?vue&type=script&lang=js"
export * from "./EtoileComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__